<div class="score-container">
  <h1>Score</h1>
    <div class="score-wrapper">
      <div class="score" [style.width.%]="getNormalizedScore() * 100"></div>
    </div>
  <p>{{ getNormalizedScore() }}</p>
</div>
